import { Alert, Box, Typography } from '@mui/material';

const NoDataComponent = ({
    title = 'No hay datos para mostrar.',
    description = 'Prueba cambiar alguno de los filtros.',
    hideTitle = false,
    hideDescription = false,
    severity = 'warning',
    fontSize = '16px',
    ...props
}) => {
    return (
        <Box
            className="no-data-container"
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
            }}
            {...props}
        >
            <Alert
                severity={severity}
                style={{ fontSize: fontSize, display: 'flex', alignItems: 'center', width: '100%' }}
            >
                {!hideTitle && (
                    <Typography variant="h5" fontSize={fontSize}>
                        {title}
                    </Typography>
                )}
                {!hideDescription && (
                    <Typography variant="h6" fontSize={fontSize}>
                        {description}
                    </Typography>
                )}
            </Alert>
        </Box>
    );
};

export default NoDataComponent;
